module.exports = __webpack_public_path__ + "static/media/img_Benchmarking404.3bc4f781.png";